import { IAnnouncement } from '../../models/messaging';
import { IDocument, IPhoto } from '../../models/resource';
import { UserAvatarData } from '../../models/user';
import { Communication } from '../models/gqlModels';

export function mapCommunicationToIAnnouncement(communication: Communication, studentId: string): IAnnouncement {
  let type = 'push' as 'email' | 'sms' | 'push';
  if (communication.email) {
    type = 'email';
  } else if (communication.sms) {
    type = 'sms';
  } else {
    type = 'push';
  }

  //type determines the avatar
  const avatar: UserAvatarData = {
    pictureUrl: type === 'email' ? 'assets/icons/email.svg' : 'assets/icons/chat.svg',
    id: studentId,
    size: 24,
    borderColour: '#14448F',
    hasNotification: false,
    isGuardian: false,
    name: communication.createdBy,
    routeEnabled: false,
    enrolmentPercent: 0,
  };

  let documents: IDocument[] | undefined = undefined;
  let photos: IPhoto[] | undefined = undefined;
  if (communication.attachments && communication.attachments.length > 0) {
    //The attachments can be documents, links, photos etc depending on the attachment extension
    documents = communication.attachments
      .filter(
        (att) =>
          att.file.extension === '.pdf' ||
          !(
            att.file.extension === '.jpg' ||
            att.file.extension === '.jpeg' ||
            att.file.extension === '.png' ||
            att.file.extension === '.gif'
          ),
      )
      .map((att) => {
        return {
          id: att.file.id,
          name: att.file.name,
          type: 'Document',
          timestamp: new Date(communication.dateCreated),
          documentUrl: `/myhub-api/api/v1/communication/${communication.id}/file/${att.file.id}/download`,
        } as IDocument;
      });

    photos = communication.attachments
      .filter(
        (att) =>
          att.file.extension === '.jpg' ||
          att.file.extension === '.jpeg' ||
          att.file.extension === '.png' ||
          att.file.extension === '.gif',
      )
      .map((att) => {
        return {
          id: att.file.id,
          name: att.file.name,
          type: 'Photo',
          timestamp: new Date(communication.dateCreated),
          imageUrl: `/myhub-api/api/v1/communication/${communication.id}/file/${att.file.id}/download`,
        } as IPhoto;
      });
  }

  //type determines the content
  let content = '';
  switch (type) {
    case 'email':
      content = communication.emails && communication.emails.length > 0 ? communication.emails[0].html : '';
      break;
    case 'sms':
      content = communication.smses && communication.smses.length > 0 ? communication.smses[0].message : '';
      break;
    default:
      content = '';
      break;
  }

  const read = communication.readStatus.length > 0;

  return {
    id: communication.id,
    type,
    sender: communication.createdBy,
    content,
    read,
    timestamp: new Date(communication.dateCreated),
    avatar,
    title: communication.title,
    documents,
    photos,
  };
}
